import { CASEBUSI_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: CASEBUSI_MNG,
  relationSearch: true,
  allowStatus: {},
  params: null,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  toolbar: {
    searchWidth: 480,
    searchPlaceholder: '请输入用例名/版本支持',
    moreBtnWidth: 160,
    searchMaxlength: 168,
    searchFieldNameArr: ['testCaseName', 'productVersion'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'caseBusiCreate'
      }
      // {
      //   slot: 'refresh-rigtht',
      //   label: '批量升级产品版本',
      //   props: {
      //     type: 'primary',
      //     icon: 'el-icon-plus'
      //   },
      //   action: 'batchUpdateBusiProduct'
      // }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: 'testcaseMng.testCaseName',
          prop: 'testCaseName',
          width: 220,
          sortField: 'testCaseName'
        },
        action: 'caseBusiDetail',
        dataType: 'link'
      },
      {
        props: {
          label: 'testcaseMng.testCaseCode',
          prop: 'testCaseCode',
          width: 120
        }
      },
      {
        props: {
          label: '版本支持',
          prop: 'productId',
          width: 240
        },
        dataType: 'custom',
        custom(row, _h, value, e) {
          return row.productVersion
        },
        filter: true,
        url: `feature/listProduct`
      },
      {
        props: {
          label: 'testcaseMng.testCaseContent',
          prop: 'testCaseContent',
          width: 220
        }
      },
      {
        props: {
          label: 'testcaseMng.testCaseScene',
          prop: 'testCaseScene'
        }
      },
      {
        props: {
          label: 'testcaseMng.testUserDemand',
          prop: 'userDemand'
        }
      },
      {
        props: {
          label: 'testcaseMng.testCaseStep',
          prop: 'testCaseStep',
          width: 220
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          width: 160,
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          label: '业务版本号',
          prop: 'busiVersion',
          sortField: 'busiVersion',
          width: 100
        }
      },
      {
        //操作
        props: {
          showBtnNum: '1'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'caseBusiEdit',
        name: 'edit'
      },
      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'caseBusiDelete',
        name: 'delete',
        confirm: {
          msg: 'tips.confirm.caseBusiMng.deleteMsg'
        }
      }
    ]
  }
}
